import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class NotificationBar extends Vue {
  @Prop() timeout!: number;
  @Prop() visibility!: boolean;
  @Prop() type!: string;
  @Prop() content!: string;

  private _closeClicked = false;
  render() {
    return (
      <v-snackbar
        color={this.type}
        bottom
        value={this.visibility && !this._closeClicked}
        timeout={this.timeout}
      >
        {this.content}
        <v-btn
          onClick={() => {
            this._closeClicked = true;
            this.$forceUpdate();
          }}
          text
          color={"white"}
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-snackbar>
    );
  }
}

const component = NotificationBar;
